module.exports = __webpack_public_path__ + "static/media/sc4.ceeca8cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/sc4.png
// module id = 109
// module chunks = 0